import { getPlatform } from '../../utils/platformUtils'
import React, { useEffect, useState, useRef } from 'react'
import {
    View,
    TextInput,
    Button,
    Alert,
    Image,
    TouchableOpacity,
    Text,
    ScrollView,
    TouchableWithoutFeedback,
    Animated,
    Keyboard,
    Dimensions,
    Platform,
} from 'react-native'
import { Ionicons, Feather } from '@expo/vector-icons'
import {
    fetchAuthSession,
    signIn,
    signUp,
    confirmSignUp,
    resetPassword as amplifyResetPassword,
    confirmResetPassword as amplifyConfirmResetPassword,
    signOut,
    getCurrentUser,
    confirmSignIn,
    updateUserAttributes,
    confirmUserAttribute,
    fetchUserAttributes,
} from 'aws-amplify/auth'
import { useNavigation } from '@react-navigation/native'
// Auth v5 removido; usar APIs modulares v6 arriba
import { Hub } from 'aws-amplify/utils'
import NavigationMain from '../navigation/stacks/MainNavigation'
import { Loader } from '../customUtils/Components/Loader'
import {
    getAppVersion,
    getPrefix,
    isBranca,
    isSP,
} from '../customUtils/AppConstants'
import { apiUrl } from '../../config/config'
import theme from '../../../theme'
import styles from './loginStyles'
import * as LocalAuthentication from 'expo-local-authentication'
import SecureStoreWeb from '../../utils/SecureStoreWeb'
import { PostsServices } from '../../../database/posts.database'
import { BottomSheetAlert } from '../modals/BottomSheetAlert'
// import { Platform } from 'react-native' // Eliminada duplicada
let BottomSheet, BottomSheetView
if (Platform.OS !== 'web') {
    const bottomSheet = require('@gorhom/bottom-sheet')
    BottomSheet = bottomSheet.default
    BottomSheetView = bottomSheet.BottomSheetView
} else {
    const CustomView = ({ style, children, ...rest }) => (
        <View style={[styles.customView, style]} {...rest}>
            {children}
        </View>
    )
    BottomSheet = CustomView
    BottomSheetView = CustomView
}
import DateTimePickerModal from 'react-native-modal-datetime-picker'
import { deleteDatabase, openDB } from '../../db/indexDB'
import { LoginTheme } from '../../../themeConstants'
import { LinearGradient } from 'expo-linear-gradient'
import {
    colorButtonTextEnabled,
    colorButtonTextDisabled,
} from '../../../themeConstants'
import { colorIcon } from '../../../themeConstants'
import { useVerification } from '../appBar/context/VerificationContext'
import Constants from 'expo-constants'
import { validateConnectionNetwork } from '../../utils/functions.utils'
import { sendRequest } from '../../utils/FetchServices'
import { Switch } from 'react-native-gesture-handler'
import { LoginBiometricsStorage } from '../../utils/LoginBiometricsStorage'
import { LoginBiometric } from './loginBiometric'
import { RecoverPasswordView } from './RecoverPasswordView'
import { getLanguageFile } from '../../translations/i18n'
import { UserServices } from '../../../database/user.database'
import { useAndroidNavBarHeight } from '../customUtils/hooks/useAndroidNavBarHeight'
import {
    SafeKeyboardAvoidingView,
    SafeScrollAvoidingView,
} from '../../../SafeKeyboardProvider'

const LIMIT_TIMEOUT_LOGIN_5_SECONDS = 5000
const LIMIT_TIMEOUT_LOGIN_15_SECONDS = 15000
const LIMIT_TIMEOUT_LOGIN_10_SECONDS = 10000
const languageFile = getLanguageFile()
const isWeb = Platform.OS === 'web'

const KeyboardDismissWrapper = ({ children }) =>
    isWeb ? (
        <>{children}</>
    ) : (
        <TouchableWithoutFeedback onPress={Keyboard.dismiss} accessible={false}>
            {children}
        </TouchableWithoutFeedback>
    )

const Login = () => {
    // navigation puede no estar disponible si este componente no está montado dentro de un Navigator
    let navigation = null
    try {
        navigation = useNavigation()
    } catch {}
    const [value, setValue] = useState(0)
    const [timeoutLimit, setTimeoutLimit] = useState(LIMIT_TIMEOUT_LOGIN_10_SECONDS)
    const loginAttemptRef = useRef(false)

    const expoConfig = Constants.expoConfig || { slug: '' }

    const ERROR_MESSAGE = {
        TITLE_NOT_EXIST: languageFile.user_does_not_exist,
        DESC_NOT_EXIT: languageFile.contact_the_administrator,

        TITLE_PASS_INVALID: languageFile.invalid_user_or_pass,
        DESC_PASS_INVALID: languageFile.info_is_not_correct,

        TITLE_NO_CONECTION: languageFile.modal_not_connected,
        DESC_NO_CONECTION: languageFile.modal_not_connected_message,
    }

    const ERROR_MESSAGES_MAP = {
        'Incorrect username or password': {
            title: ERROR_MESSAGE.TITLE_PASS_INVALID,
            desc: ERROR_MESSAGE.DESC_PASS_INVALID,
        },
        NotAuthorizedException: {
            title: ERROR_MESSAGE.TITLE_PASS_INVALID,
            desc: ERROR_MESSAGE.DESC_PASS_INVALID,
        },
        'User does not exist': {
            title: ERROR_MESSAGE.TITLE_NOT_EXIST,
            desc: ERROR_MESSAGE.DESC_NOT_EXIT,
        },
        UserNotFoundException: {
            title: ERROR_MESSAGE.TITLE_NOT_EXIST,
            desc: ERROR_MESSAGE.DESC_NOT_EXIT,
        },
        'Network error': {
            title: ERROR_MESSAGE.TITLE_NO_CONECTION,
            desc: ERROR_MESSAGE.DESC_NO_CONECTION,
        },
        'Pending sign-in attempt already in progress': {
            title: ERROR_MESSAGE.TITLE_NO_CONECTION,
            desc: ERROR_MESSAGE.DESC_NO_CONECTION,
        },
        UserAlreadyAuthenticatedException: {
            title: 'Usuario ya autenticado',
            desc: 'Ya hay una sesión activa. Cerrando sesión para continuar...',
        },
        'Password attempts exceeded': {
            title: 'Demasiados intentos fallidos',
            desc: 'Tu cuenta está temporalmente bloqueada por intentos incorrectos. Restablece tu contraseña o espera unos minutos e inténtalo nuevamente.',
        },
        'Too many failed attempts': {
            title: 'Demasiados intentos fallidos',
            desc: 'Por seguridad, la autenticación fue bloqueada temporalmente. Usa “Recuperar contraseña” para restablecer el acceso.',
        },
    }

    const [loginState, setLoginState] = useState(0)
    // const [loginState, setLoginState] = useState(stateDefault)
    const [loggedIn, setLoggedIn] = useState(false)
    const [user, setUser] = useState(null)
    const [forceLoginView, setForceLoginView] = useState(false)
    const [isButtonEnabled, setIsButtonEnabled] = useState(false)
    const [users, setDataUsers] = useState([])

    const [username, setUsername] = useState('')
    const [password, setPassword] = useState('')
    const [isLoadingButtonLogin, setIsLoadingButtonLogin] = useState(true)
    const [canCreateUser, setCanCreateUser] = useState(false)
    const [isSwitchEnabled, setIsSwitchEnabled] = useState(true)

    const [errorModal, setErrorModal] = useState({
        status: false,
        title: '',
        desc: '',
    })

    const toggleSwitch = () => setIsSwitchEnabled((previousState) => !previousState)

    const goToRecoverPassword = () => {
        setLoginState(1)
    }
    const createUser = () => {
        setLoginState(2)
    }
    const showLogin = () => {
        setLoginState(0)
    }
    const isContinueReg = (user) => {
        setLoginState(3)
        setUser(user)
    }
    const isLogged = (value) => {
        setLoggedIn(value)
    }
    const onPressRedirectLogin = async () => {
        console.log('108 ---- onPressRedirectLogin')
        setForceLoginView(true)
        setLoginState(0)
    }
    const goToLoginBiometric = () => {
        console.log('goToLoginBiometric')
        setLoginState(4)
    }

    useEffect(() => {
        if (!forceLoginView) {
            LoginBiometricsStorage.getAllDataBiometrics().then((data) => {
                if (data.length > 0 && !isWeb && !isBranca) {
                    setLoginState(4)
                    setDataUsers(data)
                } else {
                    setLoginState(0)
                    // setIsSwitchEnabled(false)
                }
            })
        }
    }, [forceLoginView])

    useEffect(() => {
        const listener = async (data) => {
            // console.log('4444 hub data2', JSON.stringify(data))
            if (
                data.payload.event == 'signIn' ||
                data.payload.event == 'signOut' ||
                data.payload.event == 'cognitoHostedUI'
            ) {
                if (data.payload.event == 'signOut') {
                    console.log('138 ---- estoy en el logout de LOGIN')
                    try {
                        await UserServices.updateLoginStatus(false)
                        let pendings = await UserServices.get_pendings_conections()
                        // console.log('123213123🚀 ~ deleteDatabase ~ pendings:', pendings)
                        if (pendings && pendings.status == 0) {
                            // console.log('1231321321 tengo datos para enviar ')
                            await UserServices.deleteAllTablesContents()
                        } else {
                            await deleteDatabase()
                        }
                    } catch (error) {
                        console.log(
                            '169 - 🚀 ~ listener ~deleteDatabase error:',
                            error,
                        )
                    }

                    setLoggedIn(false)
                    setForceLoginView(false)
                    // setIsSwitchEnabled(false)
                    setValue((prev) => prev + 1)
                } else {
                }
                //checkUser()// comento esto que no existe
            }
        }
        const unsubscribe = Hub.listen('auth', listener)
        return () => unsubscribe()
    }, [])

    useEffect(() => {
        // Verificar si ambos campos tienen valores
        if (username && password) {
            setIsButtonEnabled(true)
        } else {
            setIsButtonEnabled(false)
        }
    }, [username, password])

    const saveDataBiometrics = async (dataBiometricsUser) => {
        try {
            console.log('DATA BIOMETRICA A GUARDAR: ', dataBiometricsUser)
            if (!dataBiometricsUser) return
            const userExists = await LoginBiometricsStorage.registerUserExists(
                dataBiometricsUser.username,
            )
            console.log('USER EXISTS ==> ', userExists)
            if (userExists) return
            await LoginBiometricsStorage.addDataBiometricsUser(dataBiometricsUser)
        } catch (error) {
            console.error(
                'saveDataBiometrics - Error al guardar datos de autenticación biométrica:',
                error,
            )
        }
    }

    const handleLogin = async (userNameParam, passwordParam) => {
        console.log('termine de limpiar tablas, handleLogin ')
        Keyboard.dismiss()

        // Si hay un intento en curso, ignorar nuevos intentos sin bloquear la UI
        if (loginAttemptRef.current) {
            console.warn('Intento de login en progreso, ignorando nuevo intento.')
            return
        }

        loginAttemptRef.current = true // Bloquea nuevos intentos mientras `Auth.signIn` sigue activo

        try {
            setIsLoadingButtonLogin(true)
            let newUserName = (
                getPrefix(expoConfig.slug) + username.toLowerCase()
            ).trim()
            const userLogin = userNameParam ? userNameParam : newUserName
            const passwordLogin = passwordParam ? passwordParam : password

            const isConnected = await validateConnectionNetwork(true)

            console.log('isConnected: ', isConnected)

            // TEMPORAL: Bypass conexión en iOS para debugging (validateConnectionNetwork tiene falsos negativos)
            if (!isConnected) {
                if (getPlatform().OS === 'ios') {
                    console.log(
                        '🍎 iOS: Bypassing network validation (known issue with validateConnectionNetwork in iOS simulator)',
                    )
                    console.log(
                        '🍎 iOS: Proceeding with login despite network check failure',
                    )
                } else {
                    throw new Error('Network error')
                }
            }
            const signInWithTimeout = (userLogin, passwordLogin, timeout) => {
                console.log('🔐 Starting signIn with timeout:', timeout)
                console.log('🔐 UserLogin:', userLogin)
                console.log('🔐 Password length:', passwordLogin.length)
                console.log('🔐 Platform:', getPlatform().OS)
                console.log('🔐 Amplify configured:', typeof signIn === 'function')

                return Promise.race([
                    signIn({ username: userLogin, password: passwordLogin }), // Amplify v6 API (SRP por defecto)
                    new Promise((_, reject) =>
                        setTimeout(
                            () => reject(new Error('Network error')),
                            timeout,
                        ),
                    ),
                ])
            }

            // Variante con opciones (p.ej. USER_PASSWORD_AUTH) y timeout
            const signInWithTimeoutOptions = (
                userLogin,
                passwordLogin,
                timeout,
                options = {},
            ) => {
                console.log('🔐 Starting signIn (opts) with timeout:', {
                    timeout,
                    options,
                })
                return Promise.race([
                    signIn({
                        username: userLogin,
                        password: passwordLogin,
                        options,
                    }),
                    new Promise((_, reject) =>
                        setTimeout(
                            () => reject(new Error('Network error')),
                            timeout,
                        ),
                    ),
                ])
            }

            console.log('🔐 About to call signInWithTimeout...')

            let signInResult
            if (getPlatform().OS === 'ios') {
                // Enfoque específico para iOS con compatibilidad Expo Go
                console.log('🍎 iOS: Using Expo Go compatible approach')
                console.log('🍎 iOS: Debugging info:', {
                    userLogin: userLogin,
                    passwordLength: passwordLogin.length,
                    amplifyVersion: 'v6',
                    platform: 'iOS React Native - Expo Go',
                    timestamp: new Date().toISOString(),
                })

                try {
                    console.log('🍎 iOS: Attempting USER_PASSWORD_AUTH (no SRP)...')

                    // Primero intentar con USER_PASSWORD_AUTH que no usa SRP
                    signInResult = await signIn({
                        username: userLogin,
                        password: passwordLogin,
                        options: {
                            authFlowType: 'USER_PASSWORD_AUTH',
                            clientMetadata: {
                                platform: 'react-native-ios-expo-go',
                                authMethod: 'USER_PASSWORD_AUTH',
                            },
                        },
                    })
                    console.log(
                        '✅ iOS USER_PASSWORD_AUTH successful:',
                        signInResult,
                    )
                } catch (userPassError) {
                    console.warn('⚠️ iOS USER_PASSWORD_AUTH failed, trying SRP...')
                    console.error('USER_PASSWORD_AUTH Error:', userPassError.message)

                    try {
                        // Si USER_PASSWORD_AUTH falla, intentar SRP con más configuración
                        console.log('🍎 iOS: Attempting SRP with enhanced config...')
                        signInResult = await signIn({
                            username: userLogin,
                            password: passwordLogin,
                            options: {
                                clientMetadata: {
                                    platform: 'react-native-ios',
                                    expoGo: 'true',
                                    authMethod: 'SRP',
                                },
                            },
                        })
                        console.log('✅ iOS SRP successful:', signInResult)
                    } catch (srpError) {
                        console.error('🚨 iOS BOTH AUTH METHODS FAILED:')
                        console.error('🍎 SRP Error Name:', srpError.name)
                        console.error('🍎 SRP Error Message:', srpError.message)
                        console.error('🍎 SRP Error Code:', srpError.code)
                        console.error(
                            '🍎 SRP Error Constructor:',
                            srpError.constructor.name,
                        )

                        // Análisis detallado del error SRP
                        if (srpError.underlyingError) {
                            console.error(
                                '🍎 SRP Underlying Error:',
                                srpError.underlyingError,
                            )
                        } else {
                            console.error(
                                '🍎 SRP Underlying Error: EMPTY - This indicates Expo Go compatibility issue',
                            )
                        }

                        throw srpError
                    }
                }
            } else if (getPlatform().OS === 'web') {
                // En web intentamos primero USER_PASSWORD_AUTH (sin SRP) y si falla, fallback a SRP
                try {
                    signInResult = await signIn({
                        username: userLogin,
                        password: passwordLogin,
                        options: {
                            authFlowType: 'USER_PASSWORD_AUTH',
                            clientMetadata: {
                                platform: 'web',
                                authMethod: 'USER_PASSWORD_AUTH',
                            },
                        },
                    })
                    console.log('✅ Web USER_PASSWORD_AUTH successful')
                } catch (e1) {
                    console.warn(
                        '⚠️ Web USER_PASSWORD_AUTH failed, trying SRP...',
                        e1?.message,
                    )
                    signInResult = await signIn({
                        username: userLogin,
                        password: passwordLogin,
                        options: {
                            clientMetadata: { platform: 'web', authMethod: 'SRP' },
                        },
                    })
                    console.log('✅ Web SRP successful')
                }
            } else {
                // ANDROID: preferir USER_PASSWORD_AUTH como en iOS/Web, con fallback a SRP
                try {
                    console.log(
                        '🤖 Android: Trying USER_PASSWORD_AUTH first (no SRP)',
                    )
                    signInResult = await signInWithTimeoutOptions(
                        userLogin,
                        passwordLogin,
                        timeoutLimit,
                        {
                            authFlowType: 'USER_PASSWORD_AUTH',
                            clientMetadata: {
                                platform: 'react-native-android',
                                authMethod: 'USER_PASSWORD_AUTH',
                            },
                        },
                    )
                    console.log('✅ Android USER_PASSWORD_AUTH successful')
                } catch (e1) {
                    const msg = (e1 && (e1.message || e1.toString())) || ''
                    const name = e1?.name || ''
                    console.warn(
                        '⚠️ Android USER_PASSWORD_AUTH failed. name=',
                        name,
                        'message=',
                        msg,
                    )
                    // Si realmente es que el usuario NO existe o credenciales inválidas, no fallback a SRP para no enmascarar el error útil
                    if (
                        name === 'UserNotFoundException' ||
                        /User does not exist/i.test(msg)
                    ) {
                        throw e1
                    }
                    // Fallback a SRP con timeout sólo si no es un error claro de usuario/credenciales
                    signInResult = await signInWithTimeout(
                        userLogin,
                        passwordLogin,
                        timeoutLimit,
                    )
                    console.log('✅ Android SRP successful (fallback)')
                }
            }

            console.log('🔐 signInResult received:', signInResult)

            if (signInResult) {
                // if (signInResult && signInResult.isSignedIn) {
                setTimeoutLimit(LIMIT_TIMEOUT_LOGIN_10_SECONDS)
                if (isSwitchEnabled && !isWeb) {
                    try {
                        const dataUserSave = {
                            username: userLogin, // login
                            password: passwordLogin, // login
                            biometricsActive: isSwitchEnabled,
                            avatar: '',
                            email: '',
                            user_name: '',
                            isVisible: false,
                        }
                        await saveDataBiometrics(dataUserSave)
                        // Guardar credenciales en SecureStore para permitir re-login silencioso
                        await SecureStoreWeb.setItemAsync('username', userLogin)
                        await SecureStoreWeb.setItemAsync('password', passwordLogin)
                    } catch (e) {
                        console.warn(
                            'login.jsx: no se pudo guardar credenciales en SecureStore',
                            e?.message,
                        )
                    }
                }

                console.log('2🔐 signInResult received:', signInResult.nextStep)
                console.log(
                    '3🔐 signInResult received:',
                    signInResult.nextStep.signInStep,
                )

                if (
                    signInResult.nextStep &&
                    signInResult.nextStep.signInStep ===
                        'CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED'
                ) {
                    console.log('aca validaa el caso - new password required')

                    try {
                        const legacyUser =
                            await buildLegacyUserForPreRegister(signInResult)
                        console.log(
                            '[Login] legacyUser constructed for preregister:',
                            legacyUser,
                        )
                        isContinueReg(legacyUser) // 👈 acá mandás el user con challengeParam.userAttributes
                    } catch (error) {
                        console.error(
                            '[Login] Error processing NEW_PASSWORD_REQUIRED:',
                            error,
                        )
                        // Fallback por si algo salió muy mal: estructura mínima pero compatible
                        const fallbackUser = {
                            ...signInResult,
                            challengeParam: {
                                userAttributes: {
                                    name: '',
                                    family_name: '',
                                    email: '',
                                    phone_number: '',
                                    birthdate: '',
                                    gender: '',
                                },
                            },
                        }
                        isContinueReg(fallbackUser)
                    }

                    return // importante: no sigas el flujo normal de login
                } else {
                    try {
                        console.log('handleLogin')
                        // Forzar estado y navegación tras login exitoso
                        setLoggedIn(true)
                        setUsername('')
                        setPassword('')
                        if (navigation && navigation.reset) {
                            navigation.reset({
                                index: 0,
                                routes: [{ name: 'Main' }],
                            })
                        }
                        // En web, tras signIn exitoso marcamos loggedIn inmediatamente para evitar condiciones de carrera de sesión
                        if (getPlatform().OS === 'web') {
                            setLoggedIn(true)
                        }
                        await checkUser()
                        console.log('paso el checkUser')
                    } catch (error) {
                        throw new Error(error)
                    }
                }
            }
        } catch (error) {
            // Diagnóstico ampliado para entender mejor errores "Unknown"
            console.error('244 --- 🚀 ~ handleLogin ~ error', error)
            console.error('244 --- 🚀 ~ handleLogin ~ error.name', error?.name)
            console.error('244 --- 🚀 ~ handleLogin ~ error.message', error?.message)
            console.error('244 --- 🚀 ~ handleLogin ~ error.code', error?.code)
            try {
                console.error(
                    '244 --- cause.name:',
                    error?.cause?.name,
                    'cause.message:',
                    error?.cause?.message,
                )
            } catch {}
            try {
                console.error('244 --- underlyingError:', error?.underlyingError)
            } catch {}

            // Manejo específico para usuario ya autenticado
            const errorString = error.toString()
            if (
                error.name === 'UserAlreadyAuthenticatedException' ||
                errorString.includes('UserAlreadyAuthenticatedException') ||
                errorString.includes('There is already a signed in user')
            ) {
                console.log(
                    '🔄 Usuario ya autenticado, cerrando sesión y reintentando...',
                )
                try {
                    await signOut()
                    console.log('✅ Sesión cerrada, reintentando login...')
                    // Reintentar el login después de cerrar sesión
                    setTimeout(() => {
                        handleLogin()
                    }, 1000)
                    return
                } catch (signOutError) {
                    console.error('❌ Error cerrando sesión:', signOutError)
                }
            }

            if (
                error.message === 'Network error' ||
                error.message === 'Pending sign-in attempt already in progress'
            ) {
                setTimeoutLimit((prevTimeout) =>
                    Math.min(
                        prevTimeout + LIMIT_TIMEOUT_LOGIN_5_SECONDS,
                        LIMIT_TIMEOUT_LOGIN_15_SECONDS,
                    ),
                )
            }

            const { title, desc } = mapErrorsHandleLogin(error)

            setErrorModal({
                status: true,
                title: title,
                desc: desc,
            })
        } finally {
            setIsLoadingButtonLogin(false)
            loginAttemptRef.current = false // Permitir nuevos intentos cuando termine el actual
        }
    }

    const mapErrorsHandleLogin = (error) => {
        const message = error?.message || String(error || '')

        const matchedError = Object.keys(ERROR_MESSAGES_MAP).find((key) =>
            message.includes(key),
        )

        return matchedError
            ? ERROR_MESSAGES_MAP[matchedError]
            : {
                  title: 'Error inesperado',
                  desc: 'Ocurrió un error al iniciar sesión. Verifica tus datos o inténtalo nuevamente.',
              }
    }

    const checkUser = async () => {
        try {
            console.log('🔍 Verificando estado de usuario...')
            const db = await openDB()
            let user = await PostsServices.getUser()
            console.log('Respuesta de PostsServices.getUser():', user)

            // Si la respuesta es string, intentar parsear como JSON de forma segura
            if (typeof user === 'string') {
                try {
                    const maybeJson = user.trim()
                    if (maybeJson.startsWith('{') || maybeJson.startsWith('[')) {
                        user = JSON.parse(maybeJson)
                        console.log('Parseado como JSON:', user)
                    } else {
                        // No parece JSON válido: dejar como null sin afectar flujo
                        user = null
                    }
                } catch (parseError) {
                    console.warn(
                        'Error al parsear usuario (continuo sin usuario local):',
                        parseError?.message,
                    )
                    user = null
                }
            }

            const isConnected = await validateConnectionNetwork(true)
            // Bypass temporal para iOS: tratar como conectado incluso si validateConnectionNetwork falla
            const effectivelyConnected = isConnected || getPlatform().OS === 'ios'

            if (effectivelyConnected) {
                await fetchCreateUser()
                console.log(
                    isConnected
                        ? '✅ Conectado a internet'
                        : '🍎 iOS: Asumiendo conexión disponible',
                )

                // Usar getCurrentUser para comprobar autenticación sin tocar Identity Pool (evita 400 en web)
                let currentUser = null
                try {
                    currentUser = await getCurrentUser()
                    console.log('🔐 Usuario actual:', currentUser?.username)
                } catch (err) {
                    console.log('🔐 No authenticated user:', err?.message)
                }

                if (currentUser) {
                    setLoggedIn(true)
                    setUsername('')
                    setPassword('')
                    // Forzar navegación al home principal si navigation está disponible
                    if (navigation && navigation.reset) {
                        navigation.reset({ index: 0, routes: [{ name: 'Main' }] })
                    }
                    return
                }

                // Sin sesión Amplify: en web no continuamos como logueado solo por usuario local.
                if (getPlatform().OS === 'web') {
                    console.log(
                        '🌐 Web: requiere sesión válida de Amplify para continuar',
                    )
                    setLoggedIn(false)
                    return
                }

                // RN nativo: permitir fallback a usuario local si existe
                if (user && user.login) {
                    console.log('👤 Usuario local encontrado:', user.login)
                    setLoggedIn(true)
                    setUser(user)
                    if (navigation && navigation.reset) {
                        navigation.reset({ index: 0, routes: [{ name: 'Main' }] })
                    }
                } else {
                    console.log('❌ No hay usuario local')
                    setLoggedIn(false)
                }
            } else {
                console.log(
                    '❌ Sin conexión a internet (validateConnectionNetwork retornó false)',
                )
                // Sin conexión, solo verificar usuario local
                if (user && user.login) {
                    setLoggedIn(true)
                    setUser(user)
                    if (navigation && navigation.reset) {
                        navigation.reset({ index: 0, routes: [{ name: 'Main' }] })
                    }
                } else {
                    setLoggedIn(false)
                }
            }
        } catch (error) {
            console.error('🚀 ~ checkUser ~ error:', error)
            setLoggedIn(false)
            setUser(null)
        }
    }

    const fetchCreateUser = async () => {
        try {
            let url = `${apiUrl}/can_create_user`
            let headers = {
                platform: getPlatform().OS,
                app: expoConfig.slug,
            }
            const response = await sendRequest(url, 'GET', headers, undefined, 0, 3)

            if (!response.response) {
                console.error('Failed to can_create_user: ', response)
                return
            }

            let data = response.response
            //console.log(data)
            if (data.status === 1) {
                setCanCreateUser(data.single.canCreate)
            } else {
                setCanCreateUser(false)
            }
        } catch (error) {
            setCanCreateUser(false)
            console.log('error en get sky_active')
        }
    }

    const buildLegacyUserForPreRegister = async (signInResult) => {
        let userAttributes = {}

        try {
            // Opcional, a veces ayuda para logs
            const currentUser = await getCurrentUser()
            console.log('[Login] Current user info:', currentUser)

            // Intenta traer atributos del usuario en estado NEW_PASSWORD_REQUIRED
            userAttributes = await fetchUserAttributes()
            console.log(
                '[Login] User attributes fetched successfully:',
                userAttributes,
            )
        } catch (e) {
            console.warn(
                '[Login] Could not fetch attributes in NEW_PASSWORD state:',
                e?.message,
            )

            // Fallback: estructura vacía pero con las claves que usás en el form
            userAttributes = {
                name: '',
                family_name: '',
                email: '',
                phone_number: '',
                birthdate: '',
                gender: '',
            }
        }

        // Normalizás por si faltan cosas
        const normalizedAttrs = {
            name: userAttributes.name || '',
            family_name: userAttributes.family_name || '',
            email: userAttributes.email || '',
            phone_number: userAttributes.phone_number || '',
            birthdate: userAttributes.birthdate || '',
            gender: userAttributes.gender || '',
        }

        // 👉 Objeto “similar” al de Amplify v5
        const legacyUser = {
            ...signInResult,
            challengeParam: {
                userAttributes: normalizedAttrs,
            },
        }

        return legacyUser
    }

    const renderView = (loginState) => {
        switch (loginState) {
            case 0:
                return (
                    <LoginView
                        setLoggedIn={isLogged}
                        showCreateUser={createUser}
                        showRecovery={goToRecoverPassword}
                        isContinueReg={isContinueReg}
                        usersBiometrics={users}
                        goToLoginBiometric={goToLoginBiometric}
                        isButtonEnabled={isButtonEnabled}
                        setUsername={setUsername}
                        setPassword={setPassword}
                        setIsLoadingButtonLogin={setIsLoadingButtonLogin}
                        isLoadingButtonLogin={isLoadingButtonLogin}
                        handleLogin={handleLogin}
                        username={username}
                        password={password}
                        isSwitchEnabled={isSwitchEnabled}
                        toggleSwitch={toggleSwitch}
                        canCreateUser={canCreateUser}
                        checkUser={checkUser}
                        errorModal={errorModal}
                        setErrorModal={setErrorModal}
                    />
                )
            case 1:
                return <RecoverPasswordView showLogin={showLogin} />
            case 2:
                return <CreateUserView showLogin={showLogin} />
            case 3:
                return (
                    <ContinueRegisterUserView
                        showLogin={showLogin}
                        userAuth={user}
                    />
                )
            case 4:
                return (
                    <LoginBiometric
                        handleLoginOtherUser={onPressRedirectLogin}
                        handleLogin={handleLogin}
                        isLoadingButtonLogin={isLoadingButtonLogin}
                    />
                )
        }
    }

    return (
        <LinearGradient
            style={styles.containerGeneral}
            colors={[
                LoginTheme.loginGradientStartColor,
                LoginTheme.loginGradientEndColor,
            ]}
            start={{ x: 0, y: 0 }}
            end={{ x: 0, y: 1 }}
        >
            {/*<Text style={styles.icon_text}>dots</Text>*/}
            {renderView(loginState)}
        </LinearGradient>
    )
}

const LoginView = ({
    setLoggedIn,
    showRecovery,
    showCreateUser,
    isContinueReg,
    usersBiometrics,
    goToLoginBiometric,
    setUsername,
    setPassword,
    isLoadingButtonLogin,
    setIsLoadingButtonLogin,
    handleLogin,
    username,
    password,
    isSwitchEnabled,
    toggleSwitch,
    canCreateUser,
    checkUser,
    errorModal,
    setErrorModal,
}) => {
    const [isBiometricSupported, setIsBiometricSupported] = useState(null)
    const [hidePassword, setHidePassword] = useState(true)
    const [isButtonEnabled, setIsButtonEnabled] = useState(false)
    const [isUsernameFocused, setIsUsernameFocused] = useState(false)
    const [isPasswordFocused, setIsPasswordFocused] = useState(false)
    const hasUsernameText = username.length > 0
    const hasPasswordText = password.length > 0

    const [snapPoint, setSnapPoint] = useState('45%')

    // Detectar si el tamaño de la fuente ha sido aumentado
    useEffect(() => {
        const fontScale = 1 // PixelRatio.getFontScale()
        if (fontScale > 1) {
            setSnapPoint('55%') // Cambiar snapPoint si el tamaño de la fuente es más grande
        } else {
            setSnapPoint('50%') // Valor normal
        }
    }, [])

    // console.log('Tuki', Localization)
    // const [errorModal, setErrorModal] = useState({
    //     status: false,
    //     title: '',
    //     desc: '',
    // })

    //Descomentar para probar el cambio de idioma

    useEffect(() => {
        // Verificar si ambos campos tienen valores
        if (username && password) {
            setIsButtonEnabled(true)
        } else {
            setIsButtonEnabled(false)
        }
    }, [username, password])

    const errorModalContent = (title, desc) => {
        let button = languageFile.accept
        return (
            <BottomSheetAlert
                image={require('../../../assets/loginError.png')}
                title={title}
                desc={desc}
                button={button}
                closeBottomSheet={() =>
                    setErrorModal({
                        status: false,
                    })
                }
            />
        )
    }

    useEffect(() => {
        ;(async () => {
            const hasHardware = await LocalAuthentication.hasHardwareAsync()
            // const isEnrolled = await LocalAuthentication.isEnrolledAsync()

            const username = await SecureStoreWeb.getItemAsync('username')
            const password = await SecureStoreWeb.getItemAsync('password')

            const hasDataUser = username ? true : false && password ? true : false
            // console.log('hasHardware, hasDataUser: ', hasHardware, hasDataUser)
            setIsBiometricSupported(hasHardware && hasDataUser)
        })()
    })

    const handleBiometricLogin = async () => {
        try {
            const users = await LoginBiometricsStorage.getAllDataBiometrics()
        } catch (error) {
            console.error(
                'handleBiometricLogin - Error al iniciar sesión con autenticación biométrica:',
                error,
            )
        }
    }

    useEffect(() => {
        console.log('EFF LOGIN')
        checkUser()
        const timer = setTimeout(() => {
            // setLoading(false)
            setIsLoadingButtonLogin(false)
        }, 2000)

        return () => clearTimeout(timer)
    }, [])
    const expoConfig = Constants.expoConfig || { slug: '' }
    const navBarHeight = useAndroidNavBarHeight()

    const userText = !isSP ? languageFile.username : 'DNI'
    return (
        <>
            <KeyboardDismissWrapper>
                <View style={styles.containerLogin}>
                    <View
                        style={[
                            {
                                width: '100%',
                                alignSelf: 'center',
                                flex: 1,
                                alignItems: 'center',
                                justifyContent: 'center',
                            },
                            isWeb && { maxWidth: 436 },
                        ]}
                    >
                        <Image
                            style={styles.image}
                            source={require('../../../assets/client.png')}
                            resizeMode='contain'
                        />

                        <View style={[styles.inputContainer]}>
                            <View
                                style={[
                                    styles.inputBlock,
                                    {
                                        // borderColor:
                                        //     isUsernameFocused || hasUsernameText
                                        //         ? theme.colors.colorPrimary
                                        //         : theme.colors.mediumGray,
                                    },
                                ]}
                            >
                                <TextInput
                                    style={[
                                        styles.input,
                                        { textAlign: 'center' },
                                        isWeb && {
                                            fontSize: 15,
                                            outlineStyle: 'none',
                                        },
                                    ]}
                                    placeholder={userText}
                                    placeholderTextColor={
                                        theme.colors.inputPlaceholder
                                    }
                                    value={username}
                                    onChangeText={(text) => {
                                        setUsername(text)
                                    }}
                                    textContentType='username'
                                    onFocus={() => setIsUsernameFocused(true)}
                                    onBlur={() => setIsUsernameFocused(false)}
                                    leftIcon={{ type: 'font-awesome', name: 'user' }}
                                    autoCapitalize='none'
                                    keyboardType={'visible-password'}
                                />
                            </View>
                            <View
                                style={[
                                    styles.inputBlock,
                                    {
                                        // borderColor:
                                        //     isPasswordFocused || hasPasswordText
                                        //         ? theme.colors.colorPrimary
                                        //         : theme.colors.mediumGray,
                                        marginTop: 15,
                                    },
                                ]}
                            >
                                <TextInput
                                    style={[
                                        styles.input,
                                        { textAlign: 'center' },
                                        isWeb && {
                                            fontSize: 15,
                                            outlineStyle: 'none',
                                        },
                                    ]}
                                    placeholder={languageFile.password}
                                    placeholderTextColor={
                                        theme.colors.inputPlaceholder
                                    }
                                    secureTextEntry={hidePassword}
                                    value={password}
                                    onChangeText={(text) => {
                                        setPassword(text)
                                    }}
                                    onFocus={() => setIsPasswordFocused(true)}
                                    onBlur={() => setIsPasswordFocused(false)}
                                    leftIcon={{ type: 'font-awesome', name: 'lock' }}
                                />

                                <TouchableOpacity
                                    onPress={() => setHidePassword(!hidePassword)}
                                >
                                    <Feather
                                        name={hidePassword ? 'eye-off' : 'eye'}
                                        size={24}
                                        color={theme.colors.inputPlaceholder}
                                    />
                                </TouchableOpacity>
                            </View>
                        </View>
                        <TouchableOpacity
                            style={{ width: '100%' }}
                            onPress={() => showRecovery()}
                        >
                            <Text
                                style={[
                                    {
                                        color: LoginTheme.backButtonTextColor,
                                        fontWeight: '600',
                                        fontSize: 15,
                                        textAlign: 'center',
                                    },
                                    isWeb && { fontSize: 16 },
                                ]}
                            >
                                {languageFile.recover_password}
                            </Text>
                        </TouchableOpacity>

                        {isLoadingButtonLogin ? (
                            <View style={styles.button}>
                                <Loader />
                            </View>
                        ) : (
                            <View style={styles.buttonContainer}>
                                <View style={{ height: 12 }}></View>
                                {!isWeb && !isBranca && (
                                    <View style={[styles.switchButton]}>
                                        <View>
                                            <Switch style={{ opacity: 0 }} />
                                            <Ionicons
                                                style={{
                                                    position: 'absolute',
                                                    right: 0,
                                                }}
                                                name='finger-print-outline'
                                                size={30}
                                                color={theme.colors.colorPrimary}
                                            />
                                        </View>
                                        <Text style={[styles.switchButtonText]}>
                                            {languageFile.log_in_biometrics}
                                        </Text>
                                        <Switch
                                            value={isSwitchEnabled} // Valor actual del switch (estado)
                                            onValueChange={toggleSwitch} // Función que se ejecuta al cambiar el valor
                                            trackColor={{
                                                false: theme.colors.disabled,
                                                true: theme.colors.colorPrimary,
                                            }} // Colores para cuando está apagado o encendido
                                            thumbColor={
                                                isSwitchEnabled ? 'white' : 'white'
                                            } // Color del círculo en el interruptor
                                            ios_backgroundColor={
                                                theme.colors.disabled
                                            } // Color de fondo para iOS cuando está apagado
                                        />
                                    </View>
                                )}

                                <View style={{ height: 12 }}></View>
                                <TouchableOpacity
                                    style={[
                                        styles.mainButton,
                                        {
                                            backgroundColor: isButtonEnabled
                                                ? LoginTheme.mainButtonBackgroundColor
                                                : theme.colors.disabled,
                                        },
                                    ]}
                                    onPress={() => handleLogin()}
                                    disabled={!isButtonEnabled}
                                >
                                    <Text
                                        style={[
                                            styles.mainButtonText,
                                            {
                                                color: isButtonEnabled
                                                    ? colorButtonTextEnabled
                                                    : colorButtonTextDisabled,
                                            },
                                            isWeb && { fontSize: 16 },
                                        ]}
                                    >
                                        {languageFile.log_in}
                                    </Text>
                                </TouchableOpacity>
                            </View>
                        )}

                        {/* login biometrico */}
                        {/* {isBiometricSupported && !isWeb && <Button title={`Iniciar sesión con biometria`} onPress={handleBiometricLogin} />} */}

                        {canCreateUser ? (
                            <View style={styles.buttonContainer}>
                                <TouchableOpacity
                                    style={styles.borderButton}
                                    onPress={() => showCreateUser()}
                                >
                                    <Text
                                        style={[
                                            styles.borderButtonText,
                                            isWeb && { fontSize: 16 },
                                        ]}
                                    >
                                        {languageFile.create_user}
                                    </Text>
                                </TouchableOpacity>
                            </View>
                        ) : (
                            <></>
                        )}
                    </View>
                    <View>
                        <Text style={styles.version}>{getAppVersion()}</Text>
                        <View style={{ height: navBarHeight }} />
                    </View>

                    {errorModal.status && (
                        <View style={{ position: 'absolute', inset: 0 }}>
                            {/* <StatusBar backgroundColor={'rgba(0, 0, 0, 0.7)'} barStyle='dark-content' /> */}
                            <TouchableWithoutFeedback
                                onPress={() => setErrorModal({ status: false })}
                            >
                                <Animated.View
                                    style={styles.overlay}
                                    activeOpacity={1}
                                />
                            </TouchableWithoutFeedback>
                            {!isWeb ? (
                                <BottomSheet
                                    enableDynamicSizing={true}
                                    onClose={() => setErrorModal({ status: false })}
                                    enablePanDownToClose={true}
                                >
                                    <BottomSheetView style={styles.containerFlex}>
                                        {errorModalContent(
                                            errorModal.title,
                                            errorModal.desc,
                                        )}
                                        <View style={{ height: navBarHeight }} />
                                    </BottomSheetView>
                                </BottomSheet>
                            ) : (
                                <View style={styles.customView}>
                                    <View style={styles.bottomSheetCard}>
                                        {errorModalContent(
                                            errorModal.title,
                                            errorModal.desc,
                                        )}
                                    </View>
                                </View>
                            )}
                        </View>
                    )}
                </View>
            </KeyboardDismissWrapper>
        </>
    )
}

const CreateUserView = ({ showLogin }) => {
    const expoConfig = Constants.expoConfig || {}

    const [fields, setFields] = useState([
        { _id: '0', fields: 'Name', text: '' },
        { _id: '1', fields: 'Family Name', text: '' },
        { _id: '2', fields: 'Username', text: '' },
        { _id: '3', fields: 'Password', text: '' },
        { _id: '4', fields: 'Confirm Password', text: '' },
        { _id: '5', fields: 'Email', text: '' },
    ])
    const [confirmUser, showConfirmUser] = useState(false)
    const [code, setCode] = useState('')
    const [userName, setUserName] = useState('')
    const [isButtonEnabled, setIsButtonEnabled] = useState(false)

    useEffect(() => {
        // Verificar si todos los campos tienen valores
        const allFieldsFilled = fields.every((field) => field.text !== '')
        setIsButtonEnabled(allFieldsFilled)
    }, [fields])

    const createUser = async (fields) => {
        let anyEmpty = false
        fields.forEach((element) => {
            if (element.text === '') {
                anyEmpty = true
            }
        })
        if (anyEmpty) {
            Alert.alert(languageFile.complete_all_fields)
        }

        const [name, familyName, username, password, confirmPassword, email] =
            fields.map((item) => item.text)

        if (password != confirmPassword) {
            return Alert.alert(languageFile.passwords_do_not_match)
        }

        const newUsername = getPrefix(expoConfig.slug) + username
        setUserName(newUsername)
        try {
            const response = await signUp({
                username: newUsername,
                password,
                options: {
                    userAttributes: {
                        email,
                        name,
                        family_name: familyName,
                        preferred_username: newUsername,
                    },
                },
            })
            // phone_number: '+' + phone

            showConfirmUser(true)
        } catch (error) {
            Alert.alert('Oops', error.message)
        }
    }

    const onChangeField = (field, value) => {
        const updatedFields = fields.map((item) => {
            if (item === field) {
                return { ...item, text: value }
            }
            return item
        })
        setFields(updatedFields)
    }

    const changeCode = (value) => {
        setCode(value)
    }

    const confirmCode = async (username, code) => {
        try {
            console.log(userName, code)
            const response = await confirmSignUp({
                username,
                confirmationCode: code,
            })
            console.log(response)
            Alert.alert(languageFile.user_created_successfully)
            showLogin()
        } catch (e) {}
    }

    return (
        <>
            {!confirmUser ? (
                <ScrollView
                    style={[styles.container, isWeb && { maxWidth: 436 }]}
                    contentContainerStyle={{
                        flexGrow: 1, // hace que el contenido ocupe todo el alto disponible
                        justifyContent: 'center', // centra vertical si hay espacio
                    }}
                    showsVerticalScrollIndicator={false}
                    keyboardShouldPersistTaps='handled'
                >
                    <View style={styles.containerCreateUser}>
                        <Text style={[styles.title, styles.paddingTitle]}>
                            {languageFile.create_user}
                        </Text>
                        <Text style={[styles.note, styles.paddingTitle]}>
                            {languageFile.required_fields}*
                        </Text>
                    </View>
                    {fields.map((item, index) => (
                        <CreateUserItem
                            item={item}
                            onChange={onChangeField}
                            key={item._id}
                            index={index}
                        />
                    ))}
                    <View style={styles.buttonContainer}>
                        <TouchableOpacity
                            style={[
                                styles.mainButton,
                                {
                                    backgroundColor: isButtonEnabled
                                        ? theme.colors.colorPrimary
                                        : theme.colors.disabled,
                                },
                            ]}
                            onPress={() => createUser(fields)}
                            disabled={!isButtonEnabled}
                        >
                            <Text
                                style={[
                                    styles.mainButtonText,
                                    {
                                        color: isButtonEnabled
                                            ? 'white'
                                            : theme.colors.darkGray,
                                    },
                                ]}
                            >
                                {languageFile.create_user}
                            </Text>
                        </TouchableOpacity>
                    </View>
                    <View style={styles.buttonContainer}>
                        <TouchableOpacity
                            style={styles.borderButton}
                            onPress={() => showLogin()}
                        >
                            <Text style={styles.borderButtonText}>
                                {languageFile.back}
                            </Text>
                        </TouchableOpacity>
                    </View>
                </ScrollView>
            ) : (
                <View
                    style={[
                        styles.container,
                        { justifyContent: 'center' },
                        isWeb && { maxWidth: 436 },
                    ]}
                >
                    <Text style={styles.modalTitle}>
                        {languageFile.confirm_your_email}
                    </Text>

                    <View style={styles.inputBlock}>
                        <TextInput
                            style={styles.input}
                            placeholder={languageFile.enter_confirmation_code}
                            placeholderTextColor={theme.colors.inputPlaceholder}
                            value={code}
                            onChangeText={(text) => changeCode(text)}
                        />
                    </View>

                    <View style={styles.buttonContainer}>
                        <TouchableOpacity
                            style={styles.mainButton}
                            onPress={() => confirmCode(userName, code)}
                        >
                            <Text style={styles.mainButtonText}>
                                {languageFile.validate_code}
                            </Text>
                        </TouchableOpacity>
                    </View>

                    <View style={styles.buttonContainer}>
                        <TouchableOpacity
                            style={styles.borderButton}
                            onPress={() => showConfirmUser(false)}
                        >
                            <Text style={styles.borderButtonText}>
                                {languageFile.back}
                            </Text>
                        </TouchableOpacity>
                    </View>
                </View>
            )}
        </>
    )
}

const CreateUserItem = ({ item, onChange, index }) => {
    const [hidePassword, setHidePassword] = useState(true)
    const [number, setNumber] = useState('+549')
    const genderItems = ['Femenino', 'Masculino', 'X']
    const [itemFocused, setItemFocused] = useState(-1)
    const [date, setDate] = useState(new Date())
    const [isDatePickerVisible, setDatePickerVisibility] = useState(false)

    const showDatePicker = () => {
        setDatePickerVisibility(true)
    }

    const hideDatePicker = () => {
        setDatePickerVisibility(false)
    }

    const handleConfirm = (selectedDate) => {
        setDate(selectedDate)
        hideDatePicker()
    }

    const updateNumber = (item, text) => {
        setNumber(text)
        onChange(item, text)
    }

    useEffect(() => {
        console.log(itemFocused)
    }, [itemFocused])

    if (item.fields === 'Celular' && item.text.startsWith('+549')) {
        item.text = item.text.startsWith('+549')
            ? item.text.replace('+549', '')
            : item.text
    }

    return (
        <View style={styles.inputContainer}>
            <Text style={styles.inputTitle}>
                {item.label || item.fields}
                {item.required ? '*' : ''}
            </Text>
            <View
                style={[
                    item.fields === 'Género'
                        ? styles.genderBlock
                        : styles.inputBlock,
                    {
                        borderColor:
                            itemFocused === index
                                ? theme.colors.colorPrimary
                                : theme.colors.lightGray,
                    },
                ]}
            >
                {item.fields === 'Celular' && !item.text.startsWith('+549') && (
                    <Text autoCapitalize='none' style={styles.numberPrefix}>
                        +549
                    </Text>
                )}
                {item.fields !== 'Género' && (
                    <>
                        <TextInput
                            style={[
                                styles.input,
                                item.fields === 'Contraseña' && styles.passwordInput,
                                item.fields === 'Confirmar contraseña' &&
                                    styles.passwordInput,
                            ]}
                            placeholder={item.placeholder || item.fields}
                            placeholderTextColor={theme.colors.inputPlaceholder}
                            autoCapitalize='none'
                            secureTextEntry={
                                item.fields === languageFile.password ||
                                item.fields === 'Confirmar contraseña'
                                    ? hidePassword
                                    : false
                            }
                            keyboardType={
                                item.fields === 'Celular' ? 'numeric' : 'default'
                            }
                            maxLength={item.fields === 'Celular' ? 10 : 100}
                            onFocus={
                                item.fields === 'Fecha de nacimiento'
                                    ? showDatePicker
                                    : () => setItemFocused(index)
                            }
                            onBlur={() => setItemFocused(-1)}
                            value={
                                item.fields === 'Fecha de nacimiento'
                                    ? date.toLocaleDateString()
                                    : item.text
                            }
                            onChangeText={(text) => onChange(item, text)}
                            // showSoftInputOnFocus={false}
                        />
                        {/* {item.fields === 'Contraseña' &&
                            ((pass = item.text), (containsUpperCase = /[A-Z]/.test(pass)), (containsSpecialCharacter = /[!@#$%^&*]/.test(pass)))} */}
                    </>
                )}
                {item.fields === 'Género' && (
                    <View style={styles.genderContainer}>
                        {genderItems.map((gender) => (
                            <TouchableOpacity
                                key={gender}
                                style={[styles.genderButton]}
                                onPress={() => onChange(item, gender)}
                            >
                                <View
                                    style={{
                                        flexDirection: 'row',
                                        alignItems: 'center',
                                    }}
                                >
                                    <View
                                        style={[
                                            styles.checkbox,
                                            item.text === gender &&
                                                styles.selectedGenderButton,
                                        ]}
                                    ></View>
                                    <Text
                                        style={[
                                            styles.gender,
                                            item.text === gender &&
                                                styles.selectedGender,
                                        ]}
                                    >
                                        {gender}
                                    </Text>
                                </View>
                            </TouchableOpacity>
                        ))}
                    </View>
                )}
                {item.fields === 'Contraseña' && (
                    <TouchableOpacity onPress={() => setHidePassword(!hidePassword)}>
                        <Feather
                            name={hidePassword ? 'eye-off' : 'eye'}
                            size={24}
                            color={theme.colors.colorPrimary}
                        />
                    </TouchableOpacity>
                )}
                {item.fields === 'Confirmar contraseña' && (
                    <TouchableOpacity onPress={() => setHidePassword(!hidePassword)}>
                        <Feather
                            name={hidePassword ? 'eye-off' : 'eye'}
                            size={24}
                            color={theme.colors.colorPrimary}
                        />
                    </TouchableOpacity>
                )}
                {item.fields === 'Fecha de nacimiento' && (
                    <TouchableOpacity
                        onPress={() => setDatePickerVisibility(!isDatePickerVisible)}
                    >
                        <Feather
                            name={
                                isDatePickerVisible ? 'chevron-up' : 'chevron-down'
                            }
                            size={24}
                            color={theme.colors.colorPrimary}
                        />
                    </TouchableOpacity>
                )}
            </View>
            {item.fields === 'Confirmar contraseña' && (
                <View style={styles.paddingTop}>
                    <View style={styles.containerNote}>
                        <Text
                            style={[
                                styles.note,
                                styles.paddingNote,
                                // {
                                //     color: pass.length >= 8 ? theme.colors.colorApproved : theme.colors.textSecondary,
                                // },
                            ]}
                        >
                            {languageFile.eight_characters}
                        </Text>
                        {/* {pass.length >= 8 && <Ionicons name='checkmark-sharp' size={16} color={theme.colors.colorApproved} />} */}
                    </View>
                    <View style={styles.containerNote}>
                        <Text
                            style={[
                                styles.note,
                                styles.paddingNote,
                                // {
                                //     color: containsUpperCase ? theme.colors.colorApproved : theme.colors.textSecondary,
                                // },
                            ]}
                        >
                            {languageFile.one_uppercase_letter}
                        </Text>
                        {/* {containsUpperCase && <Ionicons name='checkmark-sharp' size={16} color={theme.colors.colorApproved} />} */}
                    </View>

                    <View style={styles.containerNote}>
                        <Text
                            style={[
                                styles.note,
                                styles.paddingNote,
                                // {
                                //     color: containsSpecialCharacter ? theme.colors.colorApproved : theme.colors.textSecondary,
                                // },
                            ]}
                        >
                            {languageFile.one_special_character}
                        </Text>
                        {/* {containsSpecialCharacter && <Ionicons name='checkmark-sharp' size={16} color={theme.colors.colorApproved} />} */}
                    </View>
                </View>
            )}

            {isDatePickerVisible && (
                <DateTimePickerModal
                    isVisible={isDatePickerVisible}
                    mode='date'
                    display='spinner'
                    onConfirm={handleConfirm}
                    onCancel={hideDatePicker}
                    headerTextIOS={languageFile.select_date}
                    confirmTextIOS={languageFile.confirm}
                    cancelTextIOS={languageFile.cancel}
                    buttonTextColorIOS={theme.colors.colorPrimary}
                />
            )}
        </View>
    )
}

const disabled = true

const ContinueRegisterUserView = ({ showLogin, userAuth }) => {
    console.log('ContinueRegisterUserView userAuth:', userAuth)
    const [fields, setFields] = useState([
        { _id: '6', required: true, fields: 'Contraseña', text: '' },
        { _id: '7', required: true, fields: 'Confirmar contraseña', text: '' },
    ])
    const [confirmUser, showConfirmUser] = useState(false)
    const [code, setCode] = useState('')
    const [userName, setUserName] = useState('')
    const [isButtonEnabled, setIsButtonEnabled] = useState(false)
    const [showErrorPassword, setShowErrorPassword] = useState(false)
    const [showErrorPassword2, setShowErrorPassword2] = useState(false)
    const [showErrorPhoneNumber, setShowErrorPhoneNumber] = useState(false)
    const [showCangedPassword, setShowCangedPassword] = useState(false)
    const [verificationCode, setVerificationCode] = useState('')
    const [verificationPhoneCode, setVerificationPhoneCode] = useState('')

    const [waitingForVerification, setWaitingForVerification] = useState(false)
    const [waitingForVerificationPhone, setWaitingForVerificationPhone] =
        useState(false)

    const { setIsVerificationPending } = useVerification()
    const navBarHeight = useAndroidNavBarHeight()

    const PREFIX = '+549'

    useEffect(() => {
        const allFieldsFilled = fields.every(
            (field) => !field.required || field.text !== '',
        )
        setIsButtonEnabled(allFieldsFilled)
    }, [fields])

    const formatPhoneNumber = (phoneNumber) => {
        if (phoneNumber !== '') {
            phoneNumber = phoneNumber.trim()

            // Verificar si el número comienza con el prefijo +549
            if (phoneNumber.startsWith('+549')) {
                // Eliminar el prefijo +549 para validar solo números después de eso
                let cleanNumber = phoneNumber.slice(4)
                // Eliminar espacios en blanco adicionales después de quitar el prefijo
                cleanNumber = cleanNumber.replace(/\s/g, '')

                if (cleanNumber.length > 10) {
                    Alert.alert(
                        languageFile.alert,
                        languageFile.enter_characters + '+549',
                        [{ text: 'OK' }],
                    )
                    cleanNumber = cleanNumber.slice(0, 10) // Tomar solo los primeros 10 caracteres
                }

                if (!/^\d+$/.test(cleanNumber)) {
                    Alert.alert(languageFile.alert, languageFile.numerical_field, [
                        { text: 'OK' },
                    ])
                    return ''
                }

                // Si cleanNumber pasó la validación, devolver el número con el prefijo +549
                return '+549' + cleanNumber
            } else {
                // Para números sin el prefijo +549

                if (!/^\d+$/.test(phoneNumber)) {
                    Alert.alert(languageFile.alert, languageFile.numerical_field, [
                        { text: 'OK' },
                    ])
                    return ''
                }

                return phoneNumber
            }
        }
        return '' // Retorna una cadena vacía si phoneNumber es vacío
    }

    const isValidDateOfBirth = (dateOfBirth) => {
        // Verificar que la fecha de nacimiento esté en el formato correcto y sea válida
        // Puedes usar una expresión regular más flexible que permita números y guiones
        const datePattern = /^\d{4}-\d{2}-\d{2}$/

        // Verificar si la fecha de nacimiento no cumple con el formato esperado
        if (!datePattern.test(dateOfBirth)) {
            // Mostrar una alerta indicando el formato correcto
            Alert.alert(languageFile.alert, languageFile.enter_date_of_birth, [
                { text: 'OK' },
            ])
            return false // Formato incorrecto, devuelve false
        }

        return true // Retorna true si el formato es correcto
    }

    const onChangeField = (field, value) => {
        const updatedFields = fields.map((item) => {
            if (item === field) {
                let updatedValue = value
                if (item.fields === 'Celular') {
                    updatedValue = formatPhoneNumber(value)
                }
                return { ...item, text: updatedValue }
            }
            return item
        })
        setFields(updatedFields)
    }

    const changeCode = (value) => {
        setCode(value)
    }

    const confirmCode = async (username, code) => {
        try {
            console.log(userName, code)
            const response = await confirmSignUp({
                username,
                confirmationCode: code,
            })
            console.log(response)
            Alert.alert(languageFile.user_created_successfully)
            showLogin()
        } catch (e) {
            console.error(e)
        }
    }

    const changePassword = async (fields) => {
        console.log('[changePassword] Fields submitted:', fields)
        // [{"_id": "6", "fields": "Contraseña", "required": true, "text": "@Bcd1234"}, {"_id": "7", "fields": "Confirmar contraseña", "required": true, "text": "@Bcd1234"}]
        // const [name, familyName, birthdate, gender, phoneNumber, email, password, confirmPassword] = fields.map((item) => item.text)
        const [password, confirmPassword] = fields.map((item) => item.text)

        console.log(
            'Validando que las contraseñas coincidan... => ',
            password,
            confirmPassword,
        )
        if (password !== confirmPassword) {
            setShowErrorPassword(true)
            return
        }

        console.log('Validando contraseña... => ', !validarPass(password))

        if (!validarPass(password)) {
            setShowErrorPassword2(true)
            return
        }

        console.log('Contraseña validada correctamente')

        try {
            // Asegurarse de que userAuth y challengeParam están definidos
            if (
                !userAuth ||
                !userAuth.challengeParam ||
                !userAuth.challengeParam.userAttributes
            ) {
                console.error('User attributes not found in userAuth:')
                throw new Error('User attributes not found')
            }

            console.log('============> Cambiando contraseña...')
            // Amplify v6: para NEW_PASSWORD_REQUIRED usar confirmSignIn con new password
            const responseConfirmSignIn = await confirmSignIn({
                challengeResponse: password,
            })
            console.log(
                '===========> responseConfirmSignIn => ',
                JSON.stringify(responseConfirmSignIn),
            )

            console.log('============> Contraseña cambiada correctamente')

            setShowCangedPassword(true)
            showLogin()
        } catch (error) {
            console.error(error)
            // Forzar el cierre de sesión si hay un error

            const errorMessage = error.message || error.toString()
            if (
                errorMessage.includes(
                    'Invalid session for the user, session is expired',
                )
            ) {
                Alert.alert(
                    languageFile.session_expired,
                    languageFile.your_session_has_expired,
                )
                // showLogin()
            } else {
                console.log('err => ', error.message)
                Alert.alert(languageFile.error, languageFile.error_occurred)
            }

            // Amplify v6 modular
            signOut()
                .then(() => {
                    console.log('Usuario desconectado')
                    showLogin()
                })
                .catch((signOutError) => {
                    console.error('Error al cerrar sesión:', signOutError.message)
                    showLogin()
                })
        }
    }

    function validarPass(pass) {
        // Verificar longitud de la contraseña
        if (pass.length < 8) {
            return false
        }

        // Verificar que tenga al menos una mayúscula
        const mayusculaRegex = /[A-Z]/
        if (!mayusculaRegex.test(pass)) {
            return false
        }

        // Verificar que tenga al menos un carácter especial
        const caracterEspecialRegex = /[!"#$%&'()*+,-./:;<=>?@[\\\]^_`{|}~]/
        if (!caracterEspecialRegex.test(pass)) {
            return false
        }

        // Si pasa todas las verificaciones, es válida
        return true
    }

    const changedPasswordContent = () => {
        let title = languageFile.change_saved_successfully
        let desc = languageFile.pass_changed_successfully
        let button = languageFile.accept

        return (
            <BottomSheetAlert
                image={require('../../../assets/loginChangedPass.png')}
                title={title}
                desc={desc}
                button={button}
                closeBottomSheet={() => setShowCangedPassword(false)}
            />
        )
    }

    const verifyEmailCode = async () => {
        try {
            // Amplify v6: confirmar atributo del usuario actual
            await confirmUserAttribute({
                userAttributeKey: 'email',
                confirmationCode: verificationCode,
            })
            console.log('Email verificado correctamente')
            setIsVerificationPending(false)
            setShowCangedPassword(true)
            showLogin()
        } catch (verificationError) {
            console.error('Error verificando el email:', verificationError.message)
            Alert.alert(
                languageFile.error,
                languageFile.email_verification_code_incorrect,
            )
        }
    }

    const verifyPhoneNumberCode = async () => {
        try {
            await confirmUserAttribute({
                userAttributeKey: 'phone_number',
                confirmationCode: verificationPhoneCode,
            })
            console.log('Número de teléfono verificado correctamente')
            setIsVerificationPending(false)
            setShowCangedPassword(true)
            showLogin()
        } catch (verificationError) {
            console.error(
                'Error verificando el teléfono:',
                verificationError.message,
            )
            Alert.alert(
                languageFile.error,
                languageFile.phone_verification_code_incorrect,
            )
        }
    }

    const errorPasswordContent2 = () => {
        let title = languageFile.cannot_create_password
        let desc = languageFile.pass_requirements
        let button = languageFile.accept

        return (
            <BottomSheetAlert
                image={require('../../../assets/loginPassInvalid.png')}
                title={title}
                desc={desc}
                button={button}
                closeBottomSheet={() => setShowErrorPassword2(false)}
            />
        )
    }

    const errorPhoneNumberContent = () => {
        let title = languageFile.enter_valid_number
        let desc = languageFile.complete_numbers
        let button = languageFile.accept

        return (
            <BottomSheetAlert
                image={require('../../../assets/loginNumberInvalid.png')}
                title={title}
                desc={desc}
                button={button}
                closeBottomSheet={() => setShowErrorPhoneNumber(false)}
            />
        )
    }

    const errorPasswordContent = () => {
        let title = languageFile.cannot_create_password
        let desc = languageFile.passwords_do_not_match
        let button = languageFile.accept

        return (
            <BottomSheetAlert
                image={require('../../../assets/loginPassNotMatch.png')}
                title={title}
                desc={desc}
                button={button}
                closeBottomSheet={() => setShowErrorPassword(false)}
            />
        )
    }

    const width = Dimensions.get('window').width

    return (
        <>
            {!confirmUser ? (
                <View style={styles.container}>
                    <SafeScrollAvoidingView
                        showsVerticalScrollIndicator={false}
                        keyboardShouldPersistTaps='handled'
                        behavior='padding'
                    >
                        <View style={styles.containerCreateUser}>
                            <Text style={[styles.title, styles.paddingTitleBis]}>
                                {languageFile.complete_your_details}
                            </Text>
                        </View>
                        <Text style={[styles.note, styles.paddingNoteBis]}>
                            {languageFile.required_fields}*
                        </Text>

                        {fields.map((item, index) => (
                            <CreateUserItem
                                item={item}
                                onChange={onChangeField}
                                key={item._id}
                                index={index}
                            />
                        ))}

                        <View style={styles.buttonContainer}>
                            <TouchableOpacity
                                style={[
                                    styles.mainButton,
                                    {
                                        backgroundColor: isButtonEnabled
                                            ? theme.colors.colorPrimary
                                            : theme.colors.disabled,
                                    },
                                ]}
                                onPress={() => changePassword(fields)}
                                disabled={!isButtonEnabled}
                            >
                                <Text
                                    style={[
                                        styles.mainButtonText,
                                        {
                                            color: isButtonEnabled
                                                ? 'white'
                                                : theme.colors.darkGray,
                                        },
                                    ]}
                                >
                                    {languageFile.confirm}
                                </Text>
                            </TouchableOpacity>
                        </View>

                        <View style={styles.buttonContainer}>
                            <TouchableOpacity
                                style={styles.borderButton}
                                onPress={() => showLogin()}
                            >
                                <Text style={styles.borderButtonText}>
                                    {languageFile.back}
                                </Text>
                            </TouchableOpacity>
                        </View>
                    </SafeScrollAvoidingView>
                </View>
            ) : (
                <SafeKeyboardAvoidingView
                    style={styles.container}
                    behavior='padding'
                >
                    <Text style={styles.modalTitle}>
                        {languageFile.confirm_your_email}
                    </Text>

                    <View style={styles.inputBlock}>
                        <TextInput
                            style={styles.input}
                            placeholder={languageFile.enter_confirmation_code}
                            placeholderTextColor={theme.colors.inputPlaceholder}
                            value={code}
                            onChangeText={(text) => changeCode(text)}
                        />
                    </View>

                    <View style={styles.buttonContainer}>
                        <TouchableOpacity
                            style={[styles.mainButton]}
                            onPress={() => confirmCode(userName, code)}
                        >
                            <Text style={styles.mainButtonText}>
                                {languageFile.validate_code}
                            </Text>
                        </TouchableOpacity>
                    </View>

                    <View style={styles.buttonContainer}>
                        <TouchableOpacity
                            style={styles.borderButton}
                            onPress={() => showConfirmUser(false)}
                        >
                            <Text style={styles.borderButtonText}>
                                {languageFile.back}
                            </Text>
                        </TouchableOpacity>
                    </View>
                </SafeKeyboardAvoidingView>
            )}

            {showErrorPassword && (
                <>
                    <TouchableWithoutFeedback
                        onPress={() => setShowErrorPassword(false)}
                    >
                        <Animated.View
                            style={{ ...styles.overlay, ...styles.opacity }}
                            activeOpacity={1}
                        />
                    </TouchableWithoutFeedback>

                    {!isWeb ? (
                        <BottomSheet
                            enableDynamicSizing={true}
                            onClose={() => setShowErrorPassword(false)}
                            enablePanDownToClose={true}
                        >
                            <BottomSheetView style={styles.containerFlex}>
                                {errorPasswordContent()}
                                <View style={{ height: navBarHeight }} />
                            </BottomSheetView>
                        </BottomSheet>
                    ) : (
                        <View style={styles.customView}>
                            <View style={styles.bottomSheetCard}>
                                {errorPasswordContent()}
                            </View>
                        </View>
                    )}
                </>
            )}
            {showErrorPassword2 && (
                <>
                    <TouchableWithoutFeedback
                        onPress={() => setShowErrorPassword2(false)}
                    >
                        <Animated.View
                            style={{ ...styles.overlay, ...styles.opacity }}
                            activeOpacity={1}
                        />
                    </TouchableWithoutFeedback>
                    {!isWeb ? (
                        <BottomSheet
                            enableDynamicSizing={true}
                            onClose={() => setShowErrorPassword2(false)}
                            enablePanDownToClose={true}
                        >
                            <BottomSheetView style={styles.containerFlex}>
                                {errorPasswordContent2()}
                                <View style={{ height: navBarHeight }} />
                            </BottomSheetView>
                        </BottomSheet>
                    ) : (
                        <View style={styles.customView}>
                            <View style={styles.bottomSheetCard}>
                                {errorPasswordContent2()}
                            </View>
                        </View>
                    )}
                </>
            )}
            {showErrorPhoneNumber && (
                <>
                    <TouchableWithoutFeedback
                        onPress={() => setShowErrorPhoneNumber(false)}
                    >
                        <Animated.View
                            style={{ ...styles.overlay, ...styles.opacity }}
                            activeOpacity={1}
                        />
                    </TouchableWithoutFeedback>
                    {!isWeb ? (
                        <BottomSheet
                            enableDynamicSizing={true}
                            onClose={() => setShowErrorPhoneNumber(false)}
                            enablePanDownToClose={true}
                        >
                            <BottomSheetView style={styles.containerFlex}>
                                {errorPhoneNumberContent()}
                                <View style={{ height: navBarHeight }} />
                            </BottomSheetView>
                        </BottomSheet>
                    ) : (
                        <View style={styles.customView}>
                            <View style={styles.bottomSheetCard}>
                                {errorPhoneNumberContent()}
                            </View>
                        </View>
                    )}
                </>
            )}
            {showCangedPassword && (
                <>
                    <TouchableWithoutFeedback
                        onPress={() => setShowCangedPassword(false)}
                    >
                        <Animated.View
                            style={{ ...styles.overlay, ...styles.opacity }}
                            activeOpacity={1}
                        />
                    </TouchableWithoutFeedback>
                    {!isWeb ? (
                        <BottomSheet
                            enableDynamicSizing={true}
                            onClose={() => setShowCangedPassword(false)}
                            enablePanDownToClose={true}
                        >
                            <BottomSheetView style={styles.containerFlex}>
                                {changedPasswordContent()}
                                <View style={{ height: navBarHeight }} />
                            </BottomSheetView>
                        </BottomSheet>
                    ) : (
                        <View style={styles.customView}>
                            <View style={styles.bottomSheetCard}>
                                {changedPasswordContent()}
                            </View>
                        </View>
                    )}
                </>
            )}
            {waitingForVerification && (
                <>
                    <Animated.View
                        style={{ ...styles.overlay, ...styles.opacity }}
                        activeOpacity={1}
                    />

                    <View style={[styles.containerEditModal]}>
                        {/* <StatusBar backgroundColor={'rgba(0, 0, 0, 0.7)'} barStyle='dark-content' /> */}

                        <Image
                            style={styles.image}
                            source={require('../../../assets/editEmail.png')}
                        />
                        <View style={styles.spacer1}></View>
                        <Text style={styles.title}>{`Estás editando tu email`}</Text>
                        <Text style={styles.description}>
                            {`Estás modificando tu email, recibirás un código en tu correo electrónico para ingresarlo. Si aún no recibiste el código, vuelve a verificarlo.`}
                        </Text>
                        <View style={styles.marginBottom}></View>
                        <View style={{ flexDirection: 'row', alignSelf: 'center' }}>
                            <TextInput
                                style={[
                                    styles.inputVerification,
                                    styles.marginHorizontal,
                                    { textAlign: 'center' },
                                ]}
                                value={verificationCode}
                                onChangeText={(text) => setVerificationCode(text)}
                                placeholder={languageFile.enter_confirmation_code}
                                placeholderTextColor={theme.colors.inputPlaceholder}
                                editable={true}
                            />
                        </View>
                        <View
                            style={[
                                styles.buttonContainer,
                                styles.paddingHorizontal,
                                styles.marginBottom,
                            ]}
                        >
                            <TouchableOpacity
                                onPress={() => verifyEmailCode()}
                                style={[
                                    styles.mainButton,
                                    {
                                        width: width - 24,
                                        backgroundColor:
                                            LoginTheme.mainButtonBackgroundColor,
                                    },
                                ]}
                            >
                                <Text style={styles.mainButtonText}>
                                    {languageFile.confirm}
                                </Text>
                            </TouchableOpacity>
                            <TouchableOpacity
                                onPress={() => showLogin()}
                                style={styles.borderRedButton}
                            >
                                <Text style={styles.borderRedButtonText}>
                                    {languageFile.cancel}
                                </Text>
                            </TouchableOpacity>
                        </View>
                    </View>
                </>
            )}
            {waitingForVerificationPhone && (
                <>
                    <Animated.View
                        style={{ ...styles.overlay, ...styles.opacity }}
                        activeOpacity={1}
                    />

                    <View style={[styles.containerEditModal]}>
                        {/* <StatusBar backgroundColor={'rgba(0, 0, 0, 0.7)'} barStyle='dark-content' /> */}

                        <Image
                            style={styles.image}
                            source={require('../../../assets/editPhone.png')}
                        />
                        <View style={styles.spacer1}></View>
                        <Text
                            style={styles.title}
                        >{`Estás editando tu teléfono`}</Text>
                        <Text style={styles.description}>
                            {`Estás modificando el número de tu celular, recibirás un código SMS para ingresarlo. Si aún no recibiste el código, vuelve a verificarlo.`}
                        </Text>
                        <View style={styles.marginBottom}></View>
                        <View style={{ flexDirection: 'row', alignSelf: 'center' }}>
                            <TextInput
                                style={[
                                    styles.inputVerification,
                                    styles.marginHorizontal,
                                    { textAlign: 'center' },
                                ]}
                                placeholder={languageFile.enter_confirmation_code}
                                placeholderTextColor={theme.colors.inputPlaceholder}
                                value={verificationPhoneCode}
                                onChangeText={(text) =>
                                    setVerificationPhoneCode(text)
                                }
                                keyboardType='numeric' // Si esperas un código numérico
                                editable={true}
                            />
                        </View>
                        <View
                            style={[
                                styles.buttonContainer,
                                styles.paddingHorizontal,
                            ]}
                        >
                            <TouchableOpacity
                                onPress={() => verifyPhoneNumberCode()}
                                style={[
                                    styles.mainButton,
                                    {
                                        width: width - 24,
                                        backgroundColor:
                                            LoginTheme.mainButtonBackgroundColor,
                                    },
                                ]}
                            >
                                <Text style={styles.mainButtonText}>
                                    {languageFile.validate_code}
                                </Text>
                            </TouchableOpacity>
                            <TouchableOpacity
                                style={styles.borderRedButton}
                                onPress={() => showLogin()}
                            >
                                <Text style={styles.borderRedButtonText}>
                                    {languageFile.cancel}
                                </Text>
                            </TouchableOpacity>
                        </View>
                    </View>
                </>
            )}
        </>
    )
}

export default Login
